export default class APPLICATION_TYPE {
  static CODE = {
    WINDOW: 'WINDOW',
    DELIVERY: 'DELIVERY',
  };

  static exists(code) {
    return Object.values(APPLICATION_TYPE.CODE).includes(code);
  }

  static name(status) {
    switch (status) {
      case APPLICATION_TYPE.CODE.WINDOW:
        return '窓口申請';
      case APPLICATION_TYPE.CODE.DELIVERY:
        return '郵送申請';
      default:
        return '';
    }
  };

}